<template>
  <controller>
    <page-header title="Negocie Já - Públicos">
      <template #side>
        <button class="btn btn-primary" @click.stop.prevent="abrirModalPublico()">Criar</button>
      </template>
    </page-header>

    <main class="main-page">
      <header class="header-page">
        <h4>Resultado de Públicos</h4>
        <input-control placeholder="Buscar por nome..." search preventSearchButton />
      </header>

      <section class="table-body">
        <table class="transparent-table">
          <thead>
            <tr>
              <th>Nome</th>
              <th class="text-right">Editar</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in publicos" :key="item.idNegocieJaPublico">
              <td>{{ item.nome }}</td>
              <td class="actions">
                <a href="#" @click.prevent="abrirModalPublico(item)">
                  <fa :icon="['fal', 'pencil']" />
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
    </main>
  </controller>

  <novo-publico
    v-if="mostrarModal"
    :forma-para-editar="publicoParaEditar"
    @fechar="fecharModal"
  />
</template>

<script>
import Controller from '@/components/template/Controller.vue'
import NovoPublico from '@/components/financeiro/negocieja/publicos/NovoPublico.vue'
import NegociaService from '@/services/negocieja.service.js'

export default {
  name: 'Publicos',
  components: { Controller, NovoPublico },
  data() {
    return {
      publicos: [],
      mostrarModal: false,
      publicoParaEditar: null
    }
  },
  mounted() {
    this.getPublicos()
  },
  methods: {
    getPublicos() {
      NegociaService.getPublicos()
        .then(res => (this.publicos = res.data))
        .catch(err => console.error('Erro ao buscar públicos:', err))
    },
    abrirModalPublico(p) {
      this.publicoParaEditar = p || null
      this.mostrarModal = true
    },
    fecharModal() {
      this.mostrarModal = false
      this.publicoParaEditar = null
      this.getPublicos()
    }
  }
}
</script>

<style lang="scss" scoped>

.main-page{
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.table-body{
  width: 100%;
  padding: $hmg_mid;
  display: flex;
  justify-content: center;
}

.transparent-table {
  width: 80%;

  td {
    border-radius: 0 !important;
    &:first-child {
      border-bottom-left-radius: none !important
    }
    &:last-child {
      border-bottom-right-radius: none !important
    }
  }
}

.transparent-table th,
.transparent-table td {
  padding: 0.75rem;
  border-bottom: $border_component;
  text-align: left;
}

.actions {
  display: flex;
  font-size: 18px;
  justify-content: center;
  align-items: center;
  text-align: center !important;
}

.header-page{
    flex-direction: column;
    display: flex;
    justify-content: center;
    width: 80%;
    padding: $hmg-mid;
    gap: 1rem;

    .input-control{
      width: 35%;
    }
}

</style>